import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PopoverController } from '@ionic/angular';
import { TRAVEL_SERVICES } from '../../shared/constants/api-constants';

@Component({
  selector: 'app-voucher-selection-popover',
  templateUrl: './voucher-selection-popover.component.html',
  styleUrls: ['./voucher-selection-popover.component.scss'],
})
export class VoucherSelectionPopoverComponent implements OnInit {

  voucherSectionsForm!: FormGroup;

  leadDetails: any;
  voucherDetails: any;
  @Input() hotelsList: any[] = [];
  @Input() showIndividualHotelSelection: boolean = false;

  @Input() onActionPerformed!: (data: any) => void;

  constructor(private fb: FormBuilder,
    private _popoverController: PopoverController
  ) { }

  ngOnInit(): void {
    this.voucherSectionsForm = this.fb.group({
      hotelsVoucher: [false],
      transportationVoucher: [false],
      routeCraftVoucher: [false]
    }, {
      validators: (form: FormGroup) => {
      const controls = ['hotelsVoucher', 'transportationVoucher', 'routeCraftVoucher'];
      const enabledChecked = controls.some(
        key => form.get(key)?.enabled && form.get(key)?.value === true
      );
      return enabledChecked ? null : { atLeastOne: true };
      }
    });

    if (this.leadDetails && this.voucherDetails) {
      if (!this.voucherDetails?.showHotels || !this.leadDetails?.travelServices?.includes(TRAVEL_SERVICES.HOTELS)) {
        this.voucherSectionsForm.get('hotelsVoucher')?.disable();
      }
      if (!this.voucherDetails?.showTransportation || !this.leadDetails?.travelServices?.includes(TRAVEL_SERVICES.TRANSPORTATION)) {
        this.voucherSectionsForm.get('transportationVoucher')?.disable();
      }
      if (!this.voucherDetails?.showSightSeeing || !this.leadDetails?.travelServices?.includes(TRAVEL_SERVICES.SIGHTSEEING)) {
        this.voucherSectionsForm.get('routeCraftVoucher')?.disable();
      }
       this.hotelsList = this.extractHotelsList();
    // Step 2 — add one checkbox control per hotel
    this.hotelsList.forEach((_, i) => {
      this.voucherSectionsForm.addControl(`hotel_${i}`, this.fb.control(false));
    });
    }
  }

  toggleFullVoucher(event: any) {
    const isChecked = event.target.checked;    
    this.voucherSectionsForm.patchValue({
      hotelsVoucher: isChecked,
      transportationVoucher: isChecked,
      routeCraftVoucher: isChecked
    });
    this.hotelsList.forEach((_, i) => {
      this.voucherSectionsForm.get(`hotel_${i}`)?.setValue(isChecked);
    });
  }
  onIndividualHotelChange(): void {
    const anyChecked = this.hotelsList.some((_, i) =>
      this.voucherSectionsForm.get(`hotel_${i}`)?.value === true
    );
    const allChecked = this.hotelsList.every((_, i) =>
      this.voucherSectionsForm.get(`hotel_${i}`)?.value === true
    );

    this.voucherSectionsForm.get('hotelsVoucher')?.setValue(anyChecked, { emitEvent: false });
  }
  onHotelsVoucherChange(event: any): void {
    const isChecked = event.target.checked;
    this.hotelsList.forEach((_, i) => {
      this.voucherSectionsForm.get(`hotel_${i}`)?.setValue(isChecked);
    });
  }
  isFullVoucherChecked(): boolean {
    const controls = ['hotelsVoucher', 'transportationVoucher', 'routeCraftVoucher'];
    const enabledControls = controls.filter(key => this.voucherSectionsForm.get(key)?.enabled);
    return enabledControls.length > 0 && enabledControls.every(key => this.voucherSectionsForm.get(key)?.value === true);
  }

  onSubmit(): void {
    if (this.voucherSectionsForm.valid) {
      const formValue = this.voucherSectionsForm.value;
      let sections: string[] = [];
      let selectedHotelIndexes: number[] | null = null;
      if (formValue.hotelsVoucher) {
        sections.push('Accommodation');

        if (this.hotelsList.length > 1) {
          const selected = this.hotelsList
            .map((hotel, i) => formValue[`hotel_${i}`] ? hotel.index : null)
            .filter(i => i !== null) as number[];

          // if none selected OR all selected → send null (means all hotels)
          selectedHotelIndexes = selected.length === 0 || selected.length === this.hotelsList.length
            ? null
            : selected;
        }
      }
      if (formValue.transportationVoucher) sections.push('Transportation');
      if (formValue.routeCraftVoucher) sections.push('RouteCraft');
       this.onActionPerformed({ sections, selectedHotelIndexes });
      this.closeModal();
    } else {
      this.voucherSectionsForm.markAllAsTouched();
    }
  }
  closeModal() {
    this._popoverController.dismiss();
  }
  private extractHotelsList(): any[] {
    const hotels: any[] = [];
    const data = this.voucherDetails?.accommodations?.[0]?.data || [];

    data.forEach((destItem: any, index: number) => {
      destItem.locations?.forEach((location: any) => {
        location.hotels?.forEach((hotel: any) => {
          hotels.push({
            index,
            hotelName: hotel.hotelName?.trim(),
            destination: destItem.destination,
            checkIn: hotel.checkIn,
            checkOut: hotel.checkOut
          });
        });
      });
    });

    return hotels;
  }

  get showIndividualHotels(): boolean {
    return this.showIndividualHotelSelection
      && this.voucherSectionsForm.get('hotelsVoucher')?.value === true
      && this.hotelsList.length > 1;
  }
}
